import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * SRDM (Máximas e Mínimas, FML.SRDM) — painel próprio, 2 linhas: SRDM e ASRDM.
 * yAccessor(d) retorna { srdm, asrdm }.
 */
class SRDMSeries extends Component {
  constructor(props) {
    super(props);
    this.srdmAccessor = this.srdmAccessor.bind(this);
    this.asrdmAccessor = this.asrdmAccessor.bind(this);
  }
  srdmAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.srdm;
  }
  asrdmAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.asrdm;
  }
  render() {
    const { strokeSrdm, strokeAsrdm, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.srdmAccessor}
          stroke={strokeSrdm}
          fill="none"
        />
        <LineSeries
          yAccessor={this.asrdmAccessor}
          stroke={strokeAsrdm}
          fill="none"
        />
      </g>
    );
  }
}

SRDMSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeSrdm: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeAsrdm: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

SRDMSeries.defaultProps = {
  strokeSrdm: { color: "#FFFF00" },
  strokeAsrdm: { color: "#FF0000" },
  className: "react-stockcharts-srdm-series",
};

export default SRDMSeries;
